<template>
    <Page header="Подписки" type="" :nopadding="false" header_pos="left">
        <template #body>
            <div class="w-full flex flex-column gap-3 overflow-hidden">
                <div v-if="!loading && subscriptions" class="w-full overflow-hidden" style="max-width:100%">
                    <AdminSubscriptionList ref="adminSubscriptionList" 
                        :subscriptions="subscriptions" 
                        :users="users" 
                        :filters="lazyParams.filters"
                        :totalSubscriptions="totalSubscriptions" 
                        :loading="loading"
                        @filter="setFilter" 
                        @lazyParams="setParams" 
                        :defaultParams="lazyParams" />
                </div>
                <Skeleton v-else width="100%" height="30px" />
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'
import AdminSubscriptionList from '@/components/admin/subscription/list.vue'
import Page from '@/components/public/page.vue'
import OrdersStat from '@/components/admin/orders_stat.vue'
import { FilterMatchMode, FilterOperator } from '@primevue/core/api'

export default {
    data() {
        return {
            loading: false,
            subscriptions: null,
            users: [],        // TODO: перенести в store
            stat: null,
            lazyParams: {
                rows: 10,
                first: 0,
                sortField: null,
                sortOrder: null,
                sort: null,
                filters: {},
            },
            filters: {
                _id: {value: '', matchMode: 'contains'}, 
                ext_subscription_id: {value: '', matchMode: 'contains'},
                subscription_token: {value: '', matchMode: 'contains'},
                user_id: {value: '', matchMode: 'contains'},
                client_id: {value: '', matchMode: 'contains'},
                project_id: {value: '', matchMode: 'contains'},
                period_unit: {value: '', matchMode: 'contains'},
                status: {value: '', matchMode: 'contains'},
                bank_code: {value: '', matchMode: 'contains'},
                created_at: { 
                    operator: FilterOperator.AND, 
                    constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] 
                },
            },
            totalSubscriptions: 0,
        }
    },
    components: {
        AdminSubscriptionList,
        OrdersStat,
        Page
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        exportCSV() {
            if (this.$refs.adminSubscriptionList && this.$refs.adminSubscriptionList.exportCSV) {
                this.$refs.adminSubscriptionList.exportCSV()
            } else {
                this.showMess('warn', 'Экспорт', 'Компонент списка недоступен')
            }
        },
        setFilter(filters) {
            this.lazyParams.filters = filters
            this.LoadSubscriptions();
        },
        setParams(params) {
            this.lazyParams = params
            this.LoadSubscriptions()
        },
        onPage(event) {
            this.lazyParams = event
        },
        async LoadSubscriptions() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const subscriptions = await this.connect.GetAdminSubscriptions(this.lazyParams.rows, this.lazyParams.first, this.lazyParams.filters, {}).then(res=>res)
            if(subscriptions.result) {
                this.subscriptions = subscriptions.data
                this.totalSubscriptions = subscriptions.total
            } else {
                this.subscriptions = []
                this.totalSubscriptions = 0
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке подписок')
            }
            this.loading = false
        },
        async LoadUsers() {
            this.loading = true
            window.scrollTo({ top: 0, behavior: 'smooth' })
            const account_data = await this.connect.GetAdminUsers().then(res=>res)
            if(account_data.result) {
                this.users = account_data.data
            } else {
                this.users = []
                this.showMess('error', 'Ошибка', 'Ошибка при загрузке пользователей')
            }
            this.loading = false
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.lazyParams.filters = this.filters

        // получим параметры из url
        const query = (this.$route.query) ? this.$route.query : {}
        if(query && query.id)           this.filters._id = {value: query.id, matchMode: 'contains'}
        if(query && query.user_id)      this.filters.user_id = {value: query.user_id, matchMode: 'contains'}
        if(query && query.client_id)    this.filters.client_id = {value: query.client_id, matchMode: 'contains'}
        if(query && query.project_id)   this.filters.project_id = {value: query.project_id, matchMode: 'contains'}

        this.LoadSubscriptions()
        this.LoadUsers()
    },
}
</script>